module.exports = __webpack_public_path__ + "img/placeholder-url-evaluation.21aed21b.png";